import {
    DTOCardFormField,
} from 'app/types/form.types'
import {
    LocationType,
} from 'app/enums/label.enums'

import {
    User,
} from './Users.types'

const getUserFormFields = (editable?:boolean): DTOCardFormField<keyof User | 'hint'>[] => {
    return [{
        title: 'General Information',
        fields: [
            {
                id: 'column1',
                fields: [
                    {
                        name: 'userName',
                        labelKey: 'Users.userName',
                        required: true,
                        disabled: !editable,
                        componentName: 'InputSingleline',
                    },
                    {
                        name: 'hint',
                        componentName: 'InputSingleline',
                        disabled: true,
                        value: 'Please add both a name and surname',
                    },

                ],
            },
            {
                id: 'column2',
                fields: [{
                    name: 'email',
                    labelKey: 'Contact.email',
                    componentName: 'InputSingleline',
                    required: true,
                    disabled: !editable,
                }],
            },
            {
                id: 'column3',
                fields: [{
                    name: 'location',
                    labelKey: 'Contact.location',
                    componentName: 'LocationObjectSelector',
                    required: true,
                    disabled: !editable,
                    filterLocationType: LocationType.ADDRESS,
                }],
            },
        ],
    }]
}

export default getUserFormFields
